var _rect, _path, _path2, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramStoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 2,
    fill: "white",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.6667C14.9456 10.6667 17.3334 13.0546 17.3334 16.0001C17.3334 17.3795 16.8097 18.6366 15.9503 19.5834M14.5834 20.6671C13.8181 21.0917 12.9373 21.3334 12.0001 21.3334C11.3871 21.3334 10.7983 21.23 10.2501 21.0397M8.66675 20.1637C7.95948 19.5967 7.39977 18.8532 7.05443 18.0001M6.68278 16.4167C6.67216 16.2793 6.66675 16.1403 6.66675 16.0001C6.66675 15.3871 6.77016 14.7983 6.96049 14.2501M7.77104 12.7501C7.95505 12.511 8.15888 12.288 8.38008 12.0834",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14V18",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L10 16",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 31,
    rx: 1.5,
    stroke: "white",
    strokeOpacity: 0.24
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramStoryIcon);
export default __webpack_public_path__ + "static/media/instagram-story-icon.d9595ab970c24c9e3d9e03e17ee4530f.svg";
export { ForwardRef as ReactComponent };